import {ApiService as BizkeytechApiService} from "../../../@bizkeytech";
import {BizFileController, OrganizationGroupController, OrganizationSettingsController, ReportingToolsController, SettingController, UiComponentsController,} from './v1';
import EmployeeProfilesController from "./v1/employee-profiles";
import ReportsController from "./v1/reports";

/**
 * The interface that houses all the available api calls related to this application.
 */
class ApiService extends BizkeytechApiService {

    /**
     * The v1 controllers of the api service.
     * We have to use this getter to access the controllers of the api service since executor is set way later in runtime.
     */
    public static get v1() {
        return {
            bizFile: new BizFileController(this.executor),
            setting: new SettingController(this.executor),
            employeeProfiles: new EmployeeProfilesController(this.executor),
            organizationSettings: new OrganizationSettingsController(this.executor),
            organizationGroup: new OrganizationGroupController(this.executor),
            reportingTools: new ReportingToolsController(this.executor),
            reports: new ReportsController(this.executor),
            uiComponent: new UiComponentsController(this.executor),
        }
    }

}

export type * as ApiServiceModels from './v1';
export * from './v1';
export default ApiService;
